var map = {
	"./组 127(2).png": "bcef",
	"./组 127(3).png": "1d33",
	"./组 127.png": "6533",
	"./组 127@2x(1).png": "4fbc",
	"./组 127@2x(2).png": "1ddc",
	"./组 127@2x(3).png": "9ad1",
	"./组 127@2x.png": "753b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbbb";